// Module
var code = "<div id=\"vuePage\"></div>";
// Exports
export default code;